export default {
  // TranspositionModal.vue
  transpositionModal: {
    titleModify: 'Modifier la transposition du morceau',
    titleTranspose: 'Transposer le morceau',
    noticeDetected: 'J\'ai détecté que la tonalité d\'origine ne correspondait pas à votre voix, j\'ai donc précelectionné la tonalité qui me semble la plus adapté. Si vous souhaitez conserver la tonalité d\'origine ou en essayer une autre, cliquez sur les boutons ci-dessous.',
    noticeExplore: 'Si vous souhaitez changer de tonalité, vous pouvez explorer les différentes possibilités en cliquant sur les boutons ci-dessous.',
    infoTitle: 'Pour bénéficier de suggestions de transposition adaptées à votre voix,',
    infoButton: 'Passer le test de plage vocale',
    infoSubtitle: '(Très fortement conseillé si vous comptez chanter par la suite)',
    warningChangeProgress: 'Attention ! Si vous changez la transposition, cela va affecter votre connaissance du morceau et donc vos progrès sur le cours.',
    warningVoiceMismatch: 'La tonalité sélectionnée ne correspond pas à votre voix, vous risquez d\'avoir des difficultés à chanter ce morceau sur cette tonalité.',
    warningPianoHarder: 'La partie piano de la tonalité sélectionnée est plus difficile.',
    keepOriginalTone: 'Conserver la tonalité d\'origine',
    changeToOriginalTone: 'Changer pour la tonalité d\'origine',
    transposeToTone: 'Transposer en {tonality} / {frenchNote}',
    stayOnCurrentTone: 'Rester sur la tonalité actuelle',
    changeToAdvisedTone: 'Changer pour la tonalité conseillée',
    returnToOriginalTone: 'Revenir à la tonalité d\'origine'
  },

  // TranspositionButton.vue
  transpositionButton: {
    tonalityLabel: 'Tonalité',
    originalTonality: 'Tonalité d\'origine',
    modifiedTonality: 'Tonalité modifiée',
    transposeButton: 'Transposer',
    transposeButtonCompact: 'Transposer ({tonality})'
  },

  // AmbitusComparator.vue
  ambitusComparator: {
    songPart: 'La partie chant du morceau',
    userRange: 'Votre plage vocale',
    low: 'Grave',
    high: 'Aigu'
  },

  // TranspositionSelector.vue
  transpositionSelector: {
    currentTonality: 'Tonalité actuelle',
    originalTonality: 'Tonalité d\'origine',
    advised: 'conseillé',
    advisedLabel: 'Conseillé'
  },

  // note.ts
  notes: {
    A: 'La',
    B: 'Si',
    C: 'Do',
    D: 'Ré',
    E: 'Mi',
    F: 'Fa',
    G: 'Sol'
  }
}
